import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnimatedRoutes from '../../global/component/organism/AnimatedRoute/AnimatedRoute.tsx';
import HcpDashboardShell from './HcpDashboardShell.tsx';
import TabbedPatientView from './Table/TabbedPatientView.tsx';
import PatientInvitationsForm from './Form/PatientInvitationsForm.tsx';
import WrappedTaskTable from './Table/TaskTable.tsx';
import TaskForm from './Form/TaskForm.tsx';
import TabbedAlertView from './Table/TabbedAlertView.tsx';
import AlertDetailForm from './Form/AlertDetailForm.tsx';
import HcpForm from '../AdminDashboard/Form/HcpForm.tsx';
import ChangePassword from '../Login/ChangePassword/ChangePassword.tsx';
import SurveyResult from '../Survey/SurveyResult.tsx';
import EICFPendingSignaturesPage from './eicf/EICFPendingSignaturesPage.tsx';
import EICFConsentSignPage from './eicf/EICFConsentSignPage.tsx';

const HcpDashboardRoute: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HcpDashboardShell />}>
                <Route index element={<Navigate to="patient" replace />} />
                <Route path="changePassword" element={<ChangePassword />} />
                <Route path="hcpProfile/:id" element={<HcpForm />} />
                <Route element={<AnimatedRoutes />}>
                    <Route path="patient" element={<TabbedPatientView />} />
                    <Route path="patient/:id" element={<PatientInvitationsForm />} />
                    <Route path="task" element={<WrappedTaskTable />} />
                    <Route path="task/:id" element={<TaskForm />} />
                    <Route path="alert" element={<TabbedAlertView />} />
                    <Route path="alert/:id" element={<AlertDetailForm />} />
                    <Route path="surveyResult/:id" element={<SurveyResult />} />
                    <Route path="eicfPending" element={<EICFPendingSignaturesPage />} />
                    <Route path="eicfConsent/:id" element={<EICFConsentSignPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/hcpDashboard/patient" replace />} />
            </Route>
        </Routes>
    );
};
export default HcpDashboardRoute;
